import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  enterManually: {
    id: "shared-ui: progressive address - enter manually",
    defaultMessage: "Enter manually",
  },
  addressLine1Label: {
    id: "shared-ui: progressive address - address line 1 label",
    defaultMessage: "Address",
  },
  addressLine2Label: {
    id: "shared-ui: progressive address - address line 2 label",
    defaultMessage: "Apt, suite or other",
  },
  addAddressLine2: {
    id: "shared-ui: progressive address - add address line 2",
    defaultMessage: "Add apt, suite or other",
  },
  cityLabel: {
    id: "shared-ui: progressive address - city label",
    defaultMessage: "City",
  },
  confirmAddress: {
    id: "shared-ui: progressive address - confirm address",
    defaultMessage: "Confirm address",
  },
  cancel: {
    id: "shared-ui: progressive address - cancel",
    defaultMessage: "Cancel",
  },
  edit: {
    id: "shared-ui: progressive address - edit",
    defaultMessage: "Edit",
  },
  remove: {
    id: "shared-ui: progressive address - remove",
    defaultMessage: "Remove",
  },
  editAddress: {
    id: "shared-ui: progressive address - edit address",
    defaultMessage: "Edit address",
  },
  removeAddress: {
    id: "shared-ui: progressive address - remove address",
    defaultMessage: "Remove address",
  },
  fieldRequired: {
    id: "shared-ui: progressive address - field required",
    defaultMessage: "{fieldLabel} is required",
  },
  invalidUsZipCode: {
    id: "shared-ui: progressive address - invalid US ZIP code",
    defaultMessage: "Enter a valid ZIP code",
  },
  confirmToContinue: {
    id: "shared-ui: progressive address - confirm to continue",
    defaultMessage: "Confirm the address to continue",
  },
  suggestionsFailed: {
    id: "shared-ui: progressive address - suggestions failed",
    defaultMessage: "We couldn't load address suggestions. Try again or enter the address manually.",
  },
  detailsFailed: {
    id: "shared-ui: progressive address - details failed",
    defaultMessage: "We couldn't load that address. Try again or enter the address manually.",
  },
});
